export function isProgramDayHash(hash = window.location.hash) {
  const id = decodeURIComponent(hash.replace(/^#/, ""));
  if (!id || id === "program") return false;
  return document.getElementById(id)?.classList.contains("program-daily-day") ?? false;
}

// Hashes that open a modal (donate, One-Click Buy); program tabs must not
// rewrite these.
export function isModalHash(hash = window.location.hash) {
  return ["#donate", "#manage-donation", "#buy"].includes(hash);
}

export function hrefFromUrl(url: URL) {
  return url.pathname + url.search.replace(/%2C/gi, ",") + url.hash;
}
